// Загрузка доступных устройств
export const CONSUMPTION_DEVICES_REQUEST =
    "consumption/DEVICES_REQUEST";

export const CONSUMPTION_DEVICES_SUCCESS =
    "consumption/DEVICES_SUCCESS";

export const CONSUMPTION_DEVICES_FAILURE =
    "consumption/DEVICES_FAILURE";

// Загрузка данных расхода
export const CONSUMPTION_DATA_REQUEST =
    "consumption/DATA_REQUEST";

export const CONSUMPTION_DATA_SUCCESS =
    "consumption/DATA_SUCCESS";

export const CONSUMPTION_DATA_FAILURE =
    "consumption/DATA_FAILURE";

// Применение фильтра
export const CONSUMPTION_FILTER_APPLY =
    "consumption/FILTER_APPLY";

// Очистка состояния страницы
export const CONSUMPTION_RESET =
    "consumption/RESET";